import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { exitSandbox, isSandboxMode } from "../lib/sandbox";
import { exitSandboxSession } from "../store/slices/appAuthSlice";
import Button from "./shared/Button";

/**
 * Slim banner shown during anonymous sandbox (demo) sessions. Reminds the
 * visitor the org is read-only and funnels them to registration.
 */
export default function SandboxBanner() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!isSandboxMode()) return null;

  const handleSignup = () => {
    exitSandbox();
    dispatch(exitSandboxSession());
    navigate("/register");
  };

  return (
    <div className="flex flex-shrink-0 items-center justify-center gap-3 border-b border-[#FD3E5E]/20 bg-[linear-gradient(135deg,rgba(253,62,94,0.12),rgba(255,143,21,0.10))] px-4 py-2 text-sm text-neutral-100 shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] backdrop-blur-sm">
      <span className="inline-flex items-center gap-2 px-2.5 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#FFB8C3]">
        Sandbox
      </span>
      <span className="text-center text-neutral-200">
        You are exploring a live demo organization in read-only mode.
      </span>
      <Button onClick={handleSignup} size="sm" variant="primary">
        Create free account
      </Button>
    </div>
  );
}
